import React from "react";
import ReactDOM from "react-dom";
import Quagga from "quagga"; // ES6

var _scannerIsRunning = false;

class BarcodeTextField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isbnState : ""}
    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.sendIsbn = this.sendIsbn.bind(this);


  }


  sendIsbn(isbn){
      this.props.isbn(isbn)
  }

  receive(isbn){
//      document.querySelector("#text-input").value = isbn;
  }

  handleClick() {
    if (_scannerIsRunning) {
      Quagga.stop();
    } else {
      this.startScanner();
    }
  }

  startScanner() {
    Quagga.init(
      {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          target: document.querySelector("#scanner-container"),
          constraints: {
            width: { "min": 450, "max": 450 },
            height: { "min": 300, "max": 300 },
            margin: 20,
            facingMode: "environment",
            aspectRatio: { "min": 1, "max": 2 }
          }
        },
        decoder: {
          readers: [
            "ean_reader",

          ],
          debug: {
            showCanvas: true,
            showPatches: true,
            showFoundPatches: true,
            showSkeleton: true,
            showLabels: true,
            showPatchLabels: true,
            showRemainingPatchLabels: true,
            boxFromPatches: {
              showTransformed: true,
              showTransformedBox: true,
              showBB: true
            }
          }
        }
      },
      function (err) {
        if (err) {
          alert("You need a camera to scan barcodes.");
//          document.querySelector("#scanner-container").innerHTML = "";

          return;
        }


        Quagga.start();

        // Set flag to is running
        //_scannerIsRunning = true;
      }
    );

    Quagga.onProcessed(function (result) {
      var drawingCtx = Quagga.canvas.ctx.overlay,
        drawingCanvas = Quagga.canvas.dom.overlay;

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(
            0,
            0,
            parseInt(drawingCanvas.getAttribute("width")),
            parseInt(drawingCanvas.getAttribute("height"))
          );
          result.boxes
            .filter(function (box) {
              return box !== result.box;
            })
            .forEach(function (box) {
              Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                color: "green",
                lineWidth: 2
              });
            });
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
            color: "#00F",
            lineWidth: 2
          });
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(
            result.line,
            { x: "x", y: "y" },
            drawingCtx,
            { color: "red", lineWidth: 3 }
          );
        }
      }
    });

    Quagga.onDetected(function (result) {
      Quagga.stop();
      let isbn = result.codeResult.code;
      this.sendIsbn(isbn)
//      document.querySelector("#text-input").value = result.codeResult.code;
      document.querySelector("#scanner-container").innerHTML = "";


    }.bind(this));
  }

  handleFileSelect(evt) {
    var files = evt.target.files; // FileList object

    var tmpImgURL = URL.createObjectURL(files[0]);

    Quagga.decodeSingle(
      {
        src: tmpImgURL,
        numOfWorkers: 0, // Needs to be 0 when used within node
        locate: true,
        inputStream: {
          size: 800 // restrict input-size to be 800px in width (long-side)
        },
        decoder: {
          readers: [
            "code_128_reader",
            "ean_reader",
            "ean_8_reader",
            "code_39_reader",
            "code_39_vin_reader",
            "codabar_reader",
            "upc_reader",
            "upc_e_reader",
            "i2of5_reader"
          ]
        }
      },
      function (result) {
        if (result) {
          if (result.codeResult != null) {
          console.log(result.codeResult.code);

//            document.querySelector("#text-input").value =
//              result.codeResult.code;
//              problema richiamo sendISBN
            this.sendIsbn(result.codeResult.code)
          } else {
            alert("not detected");
//            document.querySelector("#text-input").value = "";
          }
        } else {
          alert("not detected");
//          document.querySelector("#text-input").value = "";
        }
      }.bind(this)
    );
  }



  componentDidMount() {
    document
      .querySelector("#inputId")
      .addEventListener("change", this.handleFileSelect, false);
    this.setState({isbnState: this.props.send})
  }

  render() {
    const { isbnState } = this.state
    const button = {
            borderRadius:"20%",
            margin: "0 10px",
            color: "white",
            backgroundColor:"#4482ff",
            border:"none",
            padding:"0 10px",
            fontSize:"18px"
        }
    const scanner = {
            width:"100%",
            display: "flex",
        }
    return (
      <div style={scanner}>
        <button style={button} onClick={this.handleClick}> Scan </button>
        <input id="inputId" type="file" accept="image/*" />
      </div>
    );
  }
}

export default BarcodeTextField;

//        <input type="text" id="text-input" value={isbnState} />


